import { useNavigate } from "react-router"

import { useParams } from "src/routes/hooks"

export const useCustomNavigate = () => {
    const { bu, event } = useParams()
    const navigate = useNavigate()

    return (path: string) => {
        navigate(`/${bu}/${event}${path}`)
    }
}